'use strict';

goog.provide("Ntry.UnitSystem");

goog.require("Ntry.STATIC");
goog.require("Ntry.Utils");

Ntry.UnitSystem = function() {
    this._unit;
    this._running = false;

    this.callBackFunc = null;

    Ntry.addEventListener("unitAction", this, this.action);
    Ntry.addEventListener("run", this, function(){this._running = true});
    Ntry.addEventListener("stop", this, function(){this._running = false});

};

(function(p){
    p.FRAMES = {};

    p.update = function () {
        if (!this._unit)
            this.findUnit();
        else if (!Ntry.entityManager.hasComponent(this._unit.id, Ntry.STATIC.UNIT))
            this.findUnit();
        if (!this._unit)
            return;

        var unitComp = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.UNIT);
        var spriteComp = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.SPRITE);
        var position = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.POSITION);
        if (!position)
            position = {};

        if (unitComp.action == Ntry.STATIC.STOP)
            return;

        var frameInfo = this.FRAMES[unitComp.action];
        var frame = {};
        unitComp.direction;
        /* get frame and apply movement */
        switch(unitComp.direction) {
            case Ntry.STATIC.NORTH:
                frame = frameInfo.north;
                break;
            case Ntry.STATIC.EAST:
                frame = frameInfo.east;
                break;
            case Ntry.STATIC.SOUTH:
                frame = frameInfo.south;
                break;
            case Ntry.STATIC.WEST:
                frame = frameInfo.west;
                break;
        }

        Ntry.addVectorByDirection(
            position,
            unitComp.direction,
            this.tileSize * frameInfo.movement / frame.frame.length
        );

        /* animate */
        spriteComp.currentFrameKey = frame.key;
        spriteComp.currentFrame = frame.frame[unitComp.step];

        /* flip */
        if (frame.flip) {
            spriteComp.scaleX = - Math.abs(spriteComp.scaleX);
        } else {
            spriteComp.scaleX = Math.abs(spriteComp.scaleX);
        }

        unitComp.step++;

        /* when action end */
        if (frame.frame.length <= unitComp.step) {
            if (frameInfo.rotation)
                unitComp.direction = Ntry.STATIC.DIRECTION_MAP[
                    unitComp.direction + frameInfo.rotation];
            if (frameInfo.next == Ntry.STATIC.FAIL) {
                Ntry.dispatchEvent("complete", false, unitComp.action);
                unitComp.action = Ntry.STATIC.STOP;
            } else {
                unitComp.action = frameInfo.next;
            }

            unitComp.step = 0;
            if (this.callBackFunc) {
                this.callBackFunc.call();
                this.callBackFunc = null;
            }
        }

    };

    p.loadConfig = function() {
        var cm = Ntry.configManager;
        this.tileSize = cm.getConfig("tileSize");
        var playerType = cm.getConfig('playerType') || 'entry_bot';
        if (playerType == 'soffy' && typeof EBS2015DATA == 'object')
            this.FRAMES = EBS2015DATA.FRAMES;
        if (playerType == 'entry_bot' && typeof NtryData == 'object')
            this.FRAMES = NtryData.FRAMES;
        if (playerType == 'entry_bot' && typeof NtryDataCfest == 'object')
            this.FRAMES = NtryDataCfest.FRAMES;
        if (playerType == 'Cparty_robot' && typeof CPartyData == 'object')
            this.FRAMES = CPartyData.FRAMES;
        if (playerType == 'CpartyCar' && typeof CPartyData == 'object')
            this.FRAMES = CPartyData.CAR_FRAMES;
        if (playerType == 'Cparty_robot' && typeof StudyData == 'object')
            this.FRAMES = StudyData.FRAMES;
        if (playerType == 'CpartyCar' && typeof StudyData == 'object')
            this.FRAMES = StudyData.CAR_FRAMES;
        if (playerType == 'cpartyjr' && typeof CpartyJRData == 'object')
            this.FRAMES = CpartyJRData.FRAMES;
        if (playerType == 'juni' && typeof JRData == 'object')
            this.FRAMES = JRData.FRAMES;
        if (playerType == 'entry_bot' && typeof MazeData == 'object')
            this.FRAMES = MazeData.FRAMES;
    };

    p.findUnit = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.UNIT);

        for (var key in entities)
            this._unit = entities[key];
    };

    p.action = function (actionType, callBack) {
        if (!this._running) return;
        var unitComp = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.UNIT);

        unitComp.action = actionType;
        unitComp.step = 0;

        /* grid update */
        var frameInfo = this.FRAMES[actionType];
        if (frameInfo.gridMovement) {
            var gridComp = Ntry.entityManager.getComponent(
                this._unit.id, Ntry.STATIC.GRID);
            var newVector = Ntry.addVectorByDirection(
                 gridComp, unitComp.direction, frameInfo.gridMovement
            );
        }


        if (callBack)
            this.callBackFunc = callBack;
    };

})(Ntry.UnitSystem.prototype);
